import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Powered by <b><a href="https://aarambh.tech" target="_blank">
      <img style="width:45%" src="https://aarambh.tech/assets/aarambh_Logo.svg"/>
     </a></b>
    </span>
  `,
})
export class FooterComponent {
}
